require('./bootstrap');

// window.Vue = require('vue');
import Vue from 'vue'

import BootstrapVue from 'bootstrap-vue'; //bootstrap vue

Vue.use(BootstrapVue); // Telling Vue to use this in whole application